import {
  mediaQueryMobileMin,
  mediaQueryTabletMin,
  mediaQueryDesktopMin,
} from './mediaQueries';
import { fontFamilySecondary, fontFamilyPrimary } from './fonts';
import { colorBlack900, colorGrey400 } from './colors';

const headersCommon = `
    font-weight: 900;
    color: ${colorBlack900};
  `;

export const h1 = `
    font-family: ${fontFamilySecondary};
    font-size: 24px;
    line-height: 32px;
    ${headersCommon}
  
    @media all and ${mediaQueryTabletMin} {
      font-size: 24px;
      line-height: 28px;
    }
  
    @media all and ${mediaQueryDesktopMin} {
      font-size: 24px;
      line-height: 32px;
    }
  `;

export const h2 = `
    font-family: ${fontFamilyPrimary};
    font-size: 16px;
    line-height: 28px;
    ${headersCommon}
  
    @media all and ${mediaQueryTabletMin} {
      font-size: 16px;
      line-height: 26px;
    }
  
    @media all and ${mediaQueryDesktopMin} {
      font-size: 16px;
      line-height: 28px;
    }
  `;

export const h3 = `
    font-family: ${fontFamilySecondary};
    font-size: 16px;
    line-height: 20px;
    ${headersCommon}
  
    @media all and ${mediaQueryTabletMin} {
      font-size: 18px;
      line-height: 22px;
    }
  
    @media all and ${mediaQueryDesktopMin} {
      font-size: 22px;
      line-height: 26px;
    }
  `;

export const h4 = `
    font-family: ${fontFamilySecondary};
    font-size: 16px;
    line-height: 20px;
    ${headersCommon}
  `;

export const h5 = `
    font-family: ${fontFamilySecondary};
    font-size: 14px;
    line-height: 16px;
    ${headersCommon}
  
    @media all and ${mediaQueryTabletMin} {
      font-size: 16px;
      line-height: 18px;
    }
  
    @media all and ${mediaQueryDesktopMin} {
      font-size: 16px;
      line-height: 20px;
    }
  `;

export const h6 = `
    font-family: ${fontFamilySecondary};
    font-size: 14px;
    line-height: 18px;
    ${headersCommon}
  `;

export const pLarge = `
    font-family: ${fontFamilyPrimary};
    font-size: 14px;
    line-height: 24px;
  
    @media all and ${mediaQueryMobileMin} {
      font-size: 16px;
      line-height: 28px;
    }
  `;

export const pNormal = `
    font-family: ${fontFamilyPrimary};
    font-size: 14px;
    line-height: 24px;
    
  
    @media all and ${mediaQueryDesktopMin} {
      line-height: 24px;
    }
  `;

export const pNormalGray = `
    ${pNormal};

    color: ${colorGrey400};

    @media all and ${mediaQueryDesktopMin} {
      line-height: 18px;
    }
  `;

export const pSmallGray = `
    ${pNormalGray};

    font-size: 14px;
  `;

export const pSmall = `
    font-family: ${fontFamilyPrimary};
    font-size: 13px;
    line-height: 12px;
    
    color: ${colorGrey400};
  `;
